import Container from 'components/ui/Container';
import DataTable from 'components/ui/DataTable/data-table';
import PrimaryButton from 'components/ui/PrimaryButton';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { Cell } from 'react-table';

import {
  useListEvaluationAttemptsQuery,
  useListEvaluationTraineeQuery
} from 'redux/reducers/assignmentEvalutaion';
import { useListRoutineEnrollmentQuery } from 'redux/reducers/routine-enrollment';
import { useListTrainingCourseQuery } from 'redux/reducers/training';

interface IOptions {
  label: string;
  value: string | number;
}

const PrePostEvaluationList = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState('');
  const [evaluationId, setEvaluationId] = useState<IOptions | null>({ label: '', value: 0 });
  const [traineeId, setTraineeId] = useState<IOptions | null>({ label: '', value: 0 });
  const [isPassed, setIsPassed] = useState('');
  const [isSubmitted, setIsSubmitted] = useState('');
  const [selectedRoutine, setSelectedRoutine] = useState<any>(null);

  // Debounced search
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const timerRef = React.useRef<NodeJS.Timeout>();

  useEffect(() => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setDebouncedSearch(search);
    }, 800);
  }, [search]);

  const {
    data: attemptsData,
    isLoading,
    refetch
  } = useListEvaluationAttemptsQuery({
    page,
    pageSize,
    search: debouncedSearch,
    routineId: selectedRoutine ? Number(selectedRoutine?.value) : undefined,

    evaluationId: evaluationId?.value ? Number(evaluationId?.value) : undefined,
    traineeId: traineeId?.value ? Number(traineeId?.value) : undefined,
    isPassed: isPassed === '' ? undefined : isPassed === 'true',
    isSubmitted: isSubmitted === '' ? undefined : isSubmitted === 'true'
  });

  const { data: trainingData } = useListTrainingCourseQuery();

  const { data: EvaluationQueryData } = useListEvaluationTraineeQuery(
    Number(selectedRoutine?.value) || 0
  );

  const { data: routineEnrollUserLists } = useListRoutineEnrollmentQuery({
    routineId: selectedRoutine?.value
  });
  const data = attemptsData?.data || [];
  const totalRows = 0;

  const canNext = page * pageSize < totalRows;
  const canPrevious = page > 1;

  const columns = [
    {
      Header: 'S.N',
      Cell: ({ row }: Cell<any>) => {
        return <>{(page - 1) * pageSize + row.index + 1}</>;
      }
    },
    {
      Header: 'Routine',
      accessor: 'training_name'
    },
    {
      Header: 'Evaluation',
      accessor: 'evaluation_title'
    },
    {
      Header: 'Trainee',
      accessor: 'trainee_name'
    },
    {
      Header: 'Started At',
      accessor: 'started_at',
      Cell: ({ value }: any) => (value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : '-')
    },
    {
      Header: 'Submitted At',
      accessor: 'submitted_at',
      Cell: ({ value }: any) => (value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : '-')
    },
    {
      Header: 'Obtain Score',
      accessor: 'total_score'
    },
    {
      Header: 'Total Mark',
      accessor: 'total_marks'
    },
    {
      Header: 'Passed',
      // accessor: 'is_passed',
      Cell: (data: any) => <span>{data.row.original?.is_passed ? 'Passed' : 'Failed'}</span>
    },
    {
      Header: 'Submitted',
      // accessor: 'is_submitted',
      Cell: (data: any) => {
        return <span>{data.row.original?.is_submitted ? 'Yes' : 'No'}</span>;
      }
    }
  ];

  return (
    <Container title="Pre/Post Evaluation Attempts">
      {/* Filters Row */}
      <div className="d-flex flex-wrap gap-2 ">
        <Select
          className="col-3"
          placeholder="Select Routine"
          value={selectedRoutine}
          onChange={(option) => {
            setSelectedRoutine(option);
          }}
          options={trainingData?.data?.map((item: any) => ({
            label: `${item.training_name} - ${item.training_code}`,
            value: item.routine_master_id
          }))}
          isClearable
        />

        <Select
          //   label="Evaluation"
          className="col-3"
          options={
            EvaluationQueryData && EvaluationQueryData?.data?.length > 0
              ? EvaluationQueryData?.data.map((item: any) => ({
                  label: item?.title,
                  value: item?.id
                }))
              : []
          }
          placeholder="Select Evaluation"
          value={evaluationId}
          onChange={(val: any) => {
            if (val) {
              setEvaluationId({ label: val.label, value: val.value });
            } else {
              setEvaluationId(null);
            }
          }}
          isClearable
          isSearchable
        />

        <Select
          className="col-3"
          options={
            routineEnrollUserLists && routineEnrollUserLists?.data?.length > 0
              ? routineEnrollUserLists?.data.map((item: any) => ({
                  label: `${item?.first_name} ${item.last_name || ''} ${item.mobile_number}`,
                  value: item?.id
                }))
              : []
          }
          placeholder="Trainee"
          value={traineeId}
          onChange={(val: any) => {
            if (val) {
              setTraineeId({ label: val.label, value: val.value });
            } else {
              setTraineeId(null);
            }
          }}
          isClearable
          isSearchable
        />

        {/* <Select
          className="col-3"
            options={booleanOptions?.map((item) => ({ label: item.label, value: item.value }))}
          placeholder="All"
          value={isPassed}
          onChange={(val: any) => setIsPassed(val)}
        />

        <Select
          className="col-3"
          options={trainingData?.data?.map((item: any) => ({
            label: `${item.training_name} - ${item.training_code}`,
            value: item.routine_master_id
          }))}
          //   options={booleanOptions}
          placeholder="All"
          value={isSubmitted}
          onChange={(val: any) => setIsSubmitted(val)}
        /> */}

        {/* <div style={{ width: '120px' }}>
          <label className="form-label">Page Size</label>
          <select
            className="form-select"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
              setPage(1);
            }}>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div> */}

        <div className="col-2 " style={{ marginTop: '0px' }}>
          <PrimaryButton
            type="button"
            title="Refresh"
            onClick={() => {
              setPage(1);
              refetch();
            }}
            iconName="ri-refresh-line"
          />
        </div>
      </div>

      {/* Data Table */}
      <DataTable
        columns={columns}
        data={data}
        isLoading={isLoading}
        pagination={{
          canNext,
          canPrevious,
          prevPage: () => canPrevious && setPage(page - 1),
          nextPage: () => canNext && setPage(page + 1)
          //   currentPage: page,
          //   totalRows,
          //   pageSize
        }}
        search={false}
      />
    </Container>
  );
};

export default PrePostEvaluationList;
